import { render, staticRenderFns } from "./getDriverRechargeDetail.vue?vue&type=template&id=47f683a4&scoped=true&"
import script from "./getDriverRechargeDetail.vue?vue&type=script&lang=js&"
export * from "./getDriverRechargeDetail.vue?vue&type=script&lang=js&"
import style0 from "./getDriverRechargeDetail.vue?vue&type=style&index=0&id=47f683a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f683a4",
  null
  
)

export default component.exports